/**
 * HistorialEstudianteModal Component
 * 
 * Modal para mostrar el historial de asistencias de un estudiante.
 * Muestra tabla con fechas, estados y observaciones.
 * 
 * Basado en Image 20 del diseño
 */

import React, { useState, useEffect } from "react";
import styles from "./RegistroAsistencias.module.css";

function HistorialEstudianteModal({ estudiante, onCerrar }) {
  const [historial, setHistorial] = useState([]);
  const [paginaActual, setPaginaActual] = useState(1);
  const totalPaginas = 1;

  // Datos mock de historial
  const historialMock = [
    {
      id: 1,
      fecha: '15/10/2025',
      estado: 'PRESENTE',
      observacion: '-'
    },
    {
      id: 2,
      fecha: '02/10/2025',
      estado: 'JUSTIFICADA',
      observacion: 'Sin aviso'
    },
    {
      id: 3,
      fecha: '22/09/2024',
      estado: 'AUSENTE',
      observacion: 'Certificado médico'
    }
  ];

  useEffect(() => {
    setHistorial(historialMock);
  }, [estudiante]);

  // Cerrar modal con ESC
  useEffect(() => {
    const handleEsc = (e) => {
      if (e.key === 'Escape') onCerrar();
    };
    document.addEventListener('keydown', handleEsc);
    return () => document.removeEventListener('keydown', handleEsc);
  }, [onCerrar]);

  const getEstadoClass = (estado) => {
    const clases = {
      'PRESENTE': styles.estadoPresenteBadge,
      'AUSENTE': styles.estadoAusenteBadge,
      'TARDANZA': styles.estadoTardanzaBadge,
      'JUSTIFICADA': styles.estadoJustificadaBadge
    };
    return clases[estado] || styles.estadoPresenteBadge;
  };

  return (
    <div className={styles.modalOverlay} onClick={onCerrar}>
      <div className={styles.modalHistorial} onClick={(e) => e.stopPropagation()}>
        {/* Header del Modal */}
        <div className={styles.modalHistorialHeader}>
          <h2 className={styles.modalHistorialTitulo}>
            Historial de Estudiante: {estudiante.nombre} {estudiante.apellido}
          </h2>
        </div>

        {/* Paginación Superior */}
        <div className={styles.paginacionSuperior}>
          <button className={styles.paginacionButton} disabled={paginaActual === 1}>
            «
          </button>
          <button className={styles.paginacionButton} disabled={paginaActual === 1}>
            ‹
          </button>
          <span className={styles.paginacionTexto}>
            {paginaActual} de {totalPaginas}
          </span>
          <button className={styles.paginacionButton} disabled={paginaActual === totalPaginas}>
            ›
          </button>
          <button className={styles.paginacionButton} disabled={paginaActual === totalPaginas}>
            »
          </button>
        </div>

        {/* Tabla de Historial */}
        <div className={styles.modalHistorialTablaContainer}>
          <table className={styles.modalHistorialTabla}>
            <thead>
              <tr className={styles.modalHistorialTablaHeader}>
                <th>Fecha</th>
                <th>Estado</th>
                <th>Observación</th>
              </tr>
            </thead>
            <tbody>
              {historial.length === 0 ? (
                <tr>
                  <td colSpan={3} className={styles.sinDatos}>No hay historial disponible</td>
                </tr>
              ) : (
                historial.map((registro) => (
                  <tr key={registro.id} className={styles.modalHistorialTablaFila}>
                    <td>{registro.fecha}</td>
                    <td>
                      <span className={`${styles.estadoBadge} ${getEstadoClass(registro.estado)}`}>
                        {registro.estado}
                      </span>
                    </td>
                    <td>{registro.observacion}</td>
                  </tr>
                ))
              )}
            </tbody>
          </table>
        </div>

        {/* Botón Cerrar */}
        <div className={styles.modalHistorialBotones}>
          <button 
            className={styles.modalCerrarButton}
            onClick={onCerrar}
          >
            CERRAR
          </button>
        </div>
      </div>
    </div>
  );
}

export default HistorialEstudianteModal;
